// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"41ec1de5","480":"b92cd9b1","838":"3eec6136"}[chunkId] + ".js";
};